<template>
  <div>
    <NegativeBalanceHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">
      <NegativeBalanceFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <NegativeBalanceTable
              :countFilterParams="countFilterParams"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import NegativeBalanceHead from "./NegativeBalanceHead/NegativeBalanceHead";
  import NegativeBalanceFilter from "./NegativeBalanceFilter/NegativeBalanceFilter";
  import NegativeBalanceTable from "./NegativeBalanceTable/NegativeBalanceTable";

  export default {
    name: "NegativeBalanceTableAdmin",

    components: {
      NegativeBalanceHead,
      NegativeBalanceFilter,
      NegativeBalanceTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
